$(document).ready(function() {
    // console.log( "ready!" );
// $('ul.news-blog.blog__posts').slick({
//   dots: false,
//   infinite: false,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });
  $('.template-index #ViewAll-template--20398510014613__service_blog_49UjF8')
    .attr('href', 'https://tracklightinventions.com/pages/services');

$('.template-index .news-blog .blog__posts.articles-wrapper').slick({
  dots: false,
  arrows:true,
  infinite: true,
  prevArrow: '.cstm-prev-btn',
  nextArrow: '.cstm-next-btn',
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
     {
      breakpoint: 1900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.custom-blog-service-section ul.multicolumn-list').slick({
  dots: false,
  arrows:true,
  prevArrow: '.cstm-prev-btn',
  nextArrow: '.cstm-next-btn',
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
     {
      breakpoint: 1900,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


jQuery(document).ready(function ($) {

  var $slider = $('.process-slider');
  var minSlides = 3;

  // ORIGINAL slide count (before cloning)
  var originalSlideCount = $slider.children().length;

  // Clone slides only for layout
  if (originalSlideCount > 0 && originalSlideCount < minSlides) {
    var timesToClone = minSlides - originalSlideCount;

    for (var i = 0; i < timesToClone; i++) {
      $slider.append($slider.children().eq(i % originalSlideCount).clone());
    }
  }

  if (originalSlideCount <= minSlides) {
    $slider.addClass('custom-no-slick');  // custom class added
    return; // do not init slick
  }

  $slider.slick({
    dots: false,
    arrows: originalSlideCount > 3, // ✅ FIX
    prevArrow: '.cstm-prev-btn',
    nextArrow: '.cstm-next-btn',
    infinite: originalSlideCount > 3,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: originalSlideCount > 3
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: originalSlideCount > 1
        }
      }
    ]
  });

});


//  var $slider = $('.process-slider');
// var minSlides = 3;
// var slideCount = $slider.children().length;

// if (slideCount > 0 && slideCount < minSlides) {
//   var timesToClone = minSlides - slideCount;

//   for (var i = 0; i < timesToClone; i++) {
//     $slider.append($slider.children().eq(i % slideCount).clone());
//   }
// }

// $slider.slick({
//   dots: false,
//   arrows: true,
//    prevArrow: '.cstm-prev-btn',
//   nextArrow: '.cstm-next-btn',
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1900,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 749,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });

    
$(document).on('click', '.accordion details summary', function () {
  const $currentSummary = $(this);
  const $currentDetails = $currentSummary.closest('details');

  // Close other accordions
  $('.accordion details').not($currentDetails).each(function () {
    $(this).removeAttr('open');
    $(this).find('summary').attr('aria-expanded', 'false');
  });

  // Toggle current aria-expanded correctly
  setTimeout(function () {
    const isOpen = $currentDetails.prop('open');
    $currentSummary.attr('aria-expanded', isOpen ? 'true' : 'false');
  }, 0);
});
});